import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ceLogo from "../../assets/images/ce-logo.png";
import { IoIosArrowDown } from "../../assets/icons/vander";

export default function NavbarTwo({ navClass, manuClass, navDark }) {
  const [isMenu, setIsMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenu(!isMenu);
  };

  const closeMenu = () => {
    setIsMenu(false);
    setActiveDropdown(null);
  };

  const toggleDropdown = (dropdownName) => {
    if (activeDropdown === dropdownName) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdownName);
    }
  };

  const closeDropdown = () => {
    setActiveDropdown(null);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown')) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg ${navClass || ""} ${isScrolled ? "navbar-scrolled" : ""}`}>
      <div className="container">
        {/* Logo */}
        <Link className="navbar-brand" to="/" onClick={closeMenu}>
          <img src={ceLogo} alt="CodeElan" height="40" />
        </Link>

        {/* Mobile menu button */}
        <button
          className={`navbar-toggler ${isMenu ? "collapsed" : ""}`}
          type="button"
          onClick={toggleMenu}
          aria-expanded={isMenu}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation menu */}
        <div className={`collapse navbar-collapse ${isMenu ? "show" : ""}`} id="navbarNav">
          <ul className={`navbar-nav ms-auto ${manuClass || ""}`}>
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={closeMenu}>Home</Link>
            </li>
            
            <li className={`nav-item dropdown ${activeDropdown === 'solutions' ? 'show' : ''}`}>
              <button 
                className="nav-link dropdown-toggle" 
                onClick={() => toggleDropdown('solutions')}
                onMouseEnter={() => setActiveDropdown('solutions')}
              >
                Solutions
                <IoIosArrowDown className={`dropdown-arrow ${activeDropdown === 'solutions' ? 'rotated' : ''}`} />
              </button>
              <ul className={`dropdown-menu ${activeDropdown === 'solutions' ? 'show' : ''}`}>
                <li>
                  <a className="dropdown-item" href="https://omniscientia.codeelan.com/" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
                    Omniscientia AI
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="https://perfectus.codeelan.com/" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
                    Perfectus Testing
                  </a>
                </li>
              </ul>
            </li>

            <li className={`nav-item dropdown ${activeDropdown === 'services' ? 'show' : ''}`}>
              <button 
                className="nav-link dropdown-toggle" 
                onClick={() => toggleDropdown('services')}
                onMouseEnter={() => setActiveDropdown('services')}
              >
                Services
                <IoIosArrowDown className={`dropdown-arrow ${activeDropdown === 'services' ? 'rotated' : ''}`} />
              </button>
              <ul className={`dropdown-menu ${activeDropdown === 'services' ? 'show' : ''}`}>
                <li><Link className="dropdown-item" to="/services/cloud" onClick={closeMenu}>Cloud Foundation</Link></li>
                <li><Link className="dropdown-item" to="/services/data-aiml" onClick={closeMenu}>Data AI/ML</Link></li>
              </ul>
            </li>

            <li className={`nav-item dropdown ${activeDropdown === 'about' ? 'show' : ''}`}>
              <button 
                className="nav-link dropdown-toggle" 
                onClick={() => toggleDropdown('about')}
                onMouseEnter={() => setActiveDropdown('about')}
              >
                About
                <IoIosArrowDown className={`dropdown-arrow ${activeDropdown === 'about' ? 'rotated' : ''}`} />
              </button>
              <ul className={`dropdown-menu ${activeDropdown === 'about' ? 'show' : ''}`}>
                <li><Link className="dropdown-item" to="/aboutus" onClick={closeMenu}>Mission and Vision</Link></li>
                <li><Link className="dropdown-item" to="/aboutus/insights" onClick={closeMenu}>Case Studies</Link></li>
                <li><Link className="dropdown-item" to="/aboutus/partnership" onClick={closeMenu}>Partnerships</Link></li>
              </ul>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/careers" onClick={closeMenu}>Careers</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contactus" onClick={closeMenu}>Contact</Link>
            </li>
            <li className="nav-item ms-lg-3">
              <Link className="btn btn-gradient" to="/contactus" onClick={closeMenu}>Get Started</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
